import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import useAuth from 'hooks/helpers/useAuth';
import useAuthStore from 'clientStore/useAuthStore';
import { isTokenExpired } from 'utils/jwt';

const PrivateRoute = ({ children }) => {
  const isAuth = useAuth();
  const { accessToken, setAccessToken, setRefreshToken } = useAuthStore();

  useEffect(() => {
    // Check token expiration on mount and periodically
    if (accessToken && isTokenExpired(accessToken)) {
      // Token is expired, clear auth and redirect to login
      setAccessToken(null);
      setRefreshToken(null);
      localStorage.removeItem('authStore');
      window.location.href = '/';
    }
  }, [accessToken, setAccessToken, setRefreshToken]);

  // Check token expiration before rendering
  if (!isAuth || (accessToken && isTokenExpired(accessToken))) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
